export const removeTempProperty = (data: any) => {
  const { temp, ...rest } = data;
  return rest;
};
